import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { XCircle, CheckCircle2 } from 'lucide-react';
import { scrollToPricing } from '../utils/scrollTo';
const painPoints = ['Llegás a la sesión sin un protocolo claro y manejás el caso de memoria', 'Las obras sociales te rechazan los informes y perdés horas rehaciendo papeles', 'Tenés miedo de meter la pata con un paciente post-quirúrgico sin guía clara', 'No sabés cuánto cobrar y terminás regalando tu trabajo por miedo a perder el paciente', 'Tus pacientes abandonan el tratamiento antes del alta y vos no tenés sistema para retenerlos', 'Llegás a casa agotado con informes pendientes que tendrías que haber hecho en el consultorio', 'Nadie valora tu título porque no ven resultados concretos ni un sistema profesional detrás'];
const comparisonData = [{
  sin: 'Horas redactando informes que la obra social rechaza',
  con: '10 minutos. Plantilla lista.'
}, {
  sin: 'Protocolos improvisados sin criterio de progresión',
  con: '+100 protocolos graficados por especialidad y fase'
}, {
  sin: 'Miedo al paciente post-quirúrgico',
  con: 'Criterios objetivos de carga y progresión por fase'
}, {
  sin: 'Pacientes que abandonan sin llegar al alta',
  con: 'Sistema de recupero de pacientes incluido'
}, {
  sin: 'Documentación legal armada a las corridas',
  con: 'Consentimientos y fichas blindadas listos para imprimir'
}, {
  sin: 'Sensación de improvisar en cada sesión',
  con: 'Llegás a la sesión con todo resuelto'
}];
export const PainPoints = () => {
  return <section className="py-20 bg-white px-4 sm:px-6 lg:px-8" data-id="element-152">
      <div className="max-w-4xl mx-auto" data-id="element-153">
        <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mb-10 text-center" data-id="element-154">
          Si sos kinesiólogo independiente, esto te va a sonar conocido:
        </h2>

        <div className="space-y-4 mb-12" data-id="element-155">
          {painPoints.map((point, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="flex items-start gap-4 bg-red-50/50 p-4 rounded-xl border border-red-100" data-id="element-156">
              <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-157" />
              <p className="text-lg text-slate-700 font-medium" data-id="element-158">{point}</p>
            </motion.div>)}
        </div>

        <div className="text-center bg-slate-50 p-8 rounded-2xl border border-slate-200" data-id="element-159">
          <h3 className="text-2xl md:text-3xl font-extrabold text-slate-900 mb-8 italic" data-id="element-160">
            "¿Cuántas sesiones más vas a manejar sin un sistema?"
          </h3>
          <button onClick={scrollToPricing} className="w-full sm:w-auto bg-red-600 hover:bg-red-700 text-white text-lg font-bold py-4 px-8 rounded-xl shadow-lg hover:shadow-xl transform transition hover:-translate-y-1" data-id="element-161">
            👉 BASTA DE IMPROVISAR — QUIERO MI KINESIOLOGÍA PRÁCTICA
          </button>
        </div>
      </div>
    </section>;
};
export const ProductOverview = () => {
  return <section className="py-16 bg-teal-900 text-white px-4 sm:px-6 lg:px-8 text-center" data-id="element-162">
      <div className="max-w-4xl mx-auto" data-id="element-163">
        <p className="text-teal-300 font-bold tracking-wider uppercase mb-4" data-id="element-164">
          🏆 El Sistema N°1 para Kinesiólogos Independientes Argentinos
        </p>
        <h2 className="text-3xl md:text-5xl font-extrabold mb-6" data-id="element-165">
          KINESIOLOGÍA PRÁCTICA — Colección Completa
        </h2>
        <p className="text-xl md:text-2xl text-teal-100 mb-10" data-id="element-166">
          12 Tomos + 6 Bonus + 2 Élite — Todo resuelto, todas las
          especialidades.
        </p>

        <div className="flex flex-wrap justify-center gap-4" data-id="element-167">
          <span className="bg-teal-800 text-white px-6 py-3 rounded-full text-lg font-semibold border border-teal-700 shadow-sm" data-id="element-168">
            +280 páginas
          </span>
          <span className="bg-teal-800 text-white px-6 py-3 rounded-full text-lg font-semibold border border-teal-700 shadow-sm" data-id="element-169">
            +100 protocolos graficados
          </span>
          <span className="bg-teal-800 text-white px-6 py-3 rounded-full text-lg font-semibold border border-teal-700 shadow-sm" data-id="element-170">
            Todas las especialidades
          </span>
        </div>
      </div>
    </section>;
};
export const Comparison = () => {
  return <section className="py-20 bg-white px-4 sm:px-6 lg:px-8" data-id="element-171">
      <div className="max-w-5xl mx-auto" data-id="element-172">
        <h2 className="text-3xl md:text-4xl font-extrabold text-center text-slate-900 mb-12" data-id="element-173">
          ¿Cuánto cuesta NO tenerlo?
        </h2>

        <div className="bg-white rounded-2xl shadow-xl border border-slate-200 overflow-hidden" data-id="element-174">
          {/* Header */}
          <div className="grid grid-cols-2 bg-slate-50 border-b border-slate-200" data-id="element-175">
            <div className="p-6 text-center border-r border-slate-200" data-id="element-176">
              <h3 className="text-xl font-bold text-slate-500" data-id="element-177">
                Sin Kinesiología Práctica
              </h3>
            </div>
            <div className="p-6 text-center bg-teal-50" data-id="element-178">
              <h3 className="text-xl font-bold text-teal-800" data-id="element-179">
                Con Kinesiología Práctica
              </h3>
            </div>
          </div>

          {/* Rows */}
          <div className="divide-y divide-slate-100" data-id="element-180">
            {comparisonData.map((row, i) => <div key={i} className="grid grid-cols-2" data-id="element-181">
                <div className="p-6 border-r border-slate-100 flex items-center gap-3" data-id="element-182">
                  <XCircle className="w-5 h-5 text-red-400 flex-shrink-0" data-id="element-183" />
                  <p className="text-slate-600 font-medium" data-id="element-184">{row.sin}</p>
                </div>
                <div className="p-6 bg-teal-50/30 flex items-center gap-3" data-id="element-185">
                  <CheckCircle2 className="w-5 h-5 text-teal-600 flex-shrink-0" data-id="element-186" />
                  <p className="text-teal-900 font-bold" data-id="element-187">{row.con}</p>
                </div>
              </div>)}
          </div>
        </div>

        <div className="mt-12 text-center" data-id="element-188">
          <p className="text-xl text-slate-700 font-medium mb-8" data-id="element-189">
            El lunes podés llegar sin saber qué hacer o entrar con todo
            resuelto. Vos decidís.
          </p>
          <button onClick={scrollToPricing} className="bg-teal-700 hover:bg-teal-800 text-white text-lg font-bold py-4 px-8 rounded-xl shadow-lg hover:shadow-xl transform transition hover:-translate-y-1" data-id="element-190">
            🚀 Empezá hoy — Quiero mi sistema completo
          </button>
        </div>
      </div>
    </section>;
};